/**
 * Old Saloon — draggable carousel scrubber
 *
 * Vision renders .flickity-progress as a read-only indicator: slideshow.js
 * writes its width from Flickity's scroll event and nothing listens back.
 * This makes it a control you can click and drag, the way the scrollbar
 * under the slider on ponchooutdoors.com works.
 *
 * Deliberately built on Flickity's PUBLIC api only — Flickity.data() to find
 * the instance and select() to move it. Reaching into flkty.x or
 * positionSlider() would give a smoother scrub and would break on the next
 * Vision update, which ships its own vendor bundle.
 *
 * The instance is resolved on the first pointerdown rather than at load.
 * slideshow.js builds it when the <slide-show> custom element connects, and
 * that can land after this file runs; by the time a finger is on the bar it
 * is always up. If it somehow is not, the bar stays inert rather than
 * throwing.
 */
(function () {
  if (window.__osCarouselScrubber) return;
  window.__osCarouselScrubber = true;

  function instanceFor(bar) {
    if (typeof Flickity === 'undefined' || !Flickity.data) return null;
    // The bar is a sibling of the track, inside the section's inner wrapper.
    // True for both featured-collection and collection-list.
    var parent = bar.parentNode;
    var track = parent && parent.querySelector('.flickity-enabled');
    return track ? Flickity.data(track) : null;
  }

  /**
   * Fraction along the bar -> slide index.
   *
   * NOT fraction * (slides.length - 1). Flickity runs with contain: true
   * here, so the track stops when the last card reaches the right edge and
   * the final few slides are crowded into almost no travel. Measured against
   * a 12-card row, index mapping put a click at 50% of the bar at 72% of the
   * track and a click at 75% at 97%: the thumb ran away from the pointer.
   *
   * Each slide carries the x position Flickity will scroll to, which is the
   * same geometry the bar's width is derived from. Interpolating between the
   * first and last of those and picking the nearest slide makes the thumb
   * land where it was dropped.
   */
  function indexFor(flkty, fraction) {
    var slides = flkty.slides;
    var last = slides.length - 1;
    if (last < 1) return 0;

    if (typeof slides[0].target !== 'number') {
      return Math.round(fraction * last); // older Flickity: fall back
    }

    var wanted = slides[0].target + (slides[last].target - slides[0].target) * fraction;
    var best = 0;
    var bestDistance = Infinity;

    for (var i = 0; i <= last; i++) {
      var distance = Math.abs(slides[i].target - wanted);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = i;
      }
    }
    return best;
  }

  function seek(flkty, bar, clientX, instant) {
    var rect = bar.getBoundingClientRect();
    if (!rect.width) return;

    var fraction = (clientX - rect.left) / rect.width;
    if (document.dir === 'rtl') fraction = 1 - fraction;
    fraction = Math.max(0, Math.min(1, fraction));

    // select( index, isWrapped, isInstant )
    flkty.select(indexFor(flkty, fraction), false, instant);
  }

  function attach(bar) {
    if (bar.dataset.osScrubber) return;
    bar.dataset.osScrubber = 'true';

    var dragging = false;
    var flkty = null;

    bar.addEventListener('pointerdown', function (event) {
      flkty = instanceFor(bar);
      if (!flkty) return;

      dragging = true;
      bar.classList.add('is-scrubbing');
      try {
        bar.setPointerCapture(event.pointerId);
      } catch (e) {
        /* capture is a nicety, not a requirement */
      }
      seek(flkty, bar, event.clientX, false);
      event.preventDefault(); // stops the drag selecting text
    });

    bar.addEventListener('pointermove', function (event) {
      if (!dragging || !flkty) return;
      // Instant while the finger is down, so the track tracks the thumb
      // rather than easing behind it.
      seek(flkty, bar, event.clientX, true);
    });

    function end(event) {
      if (!dragging) return;
      dragging = false;
      bar.classList.remove('is-scrubbing');
      try {
        bar.releasePointerCapture(event.pointerId);
      } catch (e) {
        /* already released */
      }
    }

    bar.addEventListener('pointerup', end);
    bar.addEventListener('pointercancel', end);
  }

  function init() {
    var bars = document.querySelectorAll('.flickity-progress');
    for (var i = 0; i < bars.length; i++) attach(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
